import React from "react";
import {
  Button,
  Paper,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
  Avatar,
} from "@material-ui/core";
import toastType from "../../API/CallUtils/tostyNotification";
import User from "../../API/Users";
const styles = (theme) => ({
  PaperDialog: {
    //height: "85vh",
    width: "100%",
    //padding: "1%",
  },
  Radio: {
    margin: "2%",
    width: "51%",
  },
  textField: {
    width: "88%",
  },
});

class EditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { Info: {} };
  }
  componentDidMount = async () => {
    try {
      console.log(this.props.Info);
      if (this.props.Info) {
        var temp = this.props.Info.UserProfile;
        temp.email = this.props.Info.email;
        temp.UserUuid = this.props.Info.UserProfile.uuid;

        this.setState({
          Info: temp,
        });
      } else {
        toastType.error("No hay datos");
      }
    } catch (error) {
      toastType.error("Error");
      console.log(error);
    }
  };

  onChange = (event) => {
    console.log("llego", event);
    var Info = { ...this.state.Info };
    Info[event.target.name] = event.target.value;
    this.setState({ Info });
  };

  Save = async () => {
    try {
      const save = await User.Update(this.state.Info);
      if (save.UserUpdateProfile.status === "success") {
        this.props.Refresh("EditProfileDialog");
        toastType.success("Guardado");
      } else {
        toastType.error("No fue posible Guardar");
      }
    } catch (error) {
      toastType.error("Error de conexión");
      console.log(error);
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.props.DialogOpen}
        onClose={this.props.DialogClose}
        maxWidth="md"
      >
        <DialogTitle>Editar</DialogTitle>
        <DialogContent className={classes.PaperDialog}>
          <Paper className={classes.PaperDialog}>
            <Grid
              item
              xs={12}
              className={classes.PaperDialog}
              container
              //direction="column"
              justify="flex-start"
              alignItems="flex-start"
            >
              <Grid
                container
                iteam
                xs={12}
                //direction="column"
                justify="center"
                alignItems="center"
                className={classes.PaperDialog}
              >
                <Avatar className={classes.large} />
              </Grid>
              <Grid
                container
                iteam
                xs={12}
                direction="column"
                justify="center"
                alignItems="center"
              >
                <TextField
                  label="Nombre"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  onChange={this.onChange}
                  name="name"
                  value={this.state.Info.name}
                />
                <TextField
                  label="Apellidos"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  onChange={this.onChange}
                  name="lastNames"
                  value={this.state.Info.lastNames}
                />
                <TextField
                  label="Sexo"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  //onChange={this.onChange}
                  //name="sex"
                  value={this.state.Info.sex ? this.state.Info.sex : "N/A"}
                />
                <TextField
                  label="Teléfono"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  onChange={this.onChange}
                  name="mobilePhone"
                  value={this.state.Info.mobilePhone}
                />
                <TextField
                  label="E-mail"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  onChange={this.onChange}
                  name="email"
                  value={this.state.Info.email}
                />
              </Grid>
            </Grid>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.DialogClose} color="secondary">
            Cancelar
          </Button>
          <Button onClick={this.Save} color="primary">
            Guardar
          </Button>
          ,
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(EditDialog);
